import { createSlice } from '../../../../utils/@reduxjs/toolkit';
import { PaginationState } from './types';
import { reducers } from './reducers';

export const initialState: PaginationState = {
  limit: 25,
  skip: 0,
  page: 1,
  totalPages: 1,
  totalItemsCount: 0,
};

const slice = createSlice({
  name: 'pagination',
  initialState,
  reducers,
});

export const { actions: paginationActions } = slice;
export const { reducer: paginationReducer } = slice;
